module.exports = __webpack_public_path__ + "static/media/bus-icon-map.caf26f23.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/peterpan/bus-icon-map.svg
// module id = 789
// module chunks = 0